import { makeStyles } from "@material-ui/core";
import { format, getDate } from "date-fns";
import {
  getDateFormats,
  getDateTimeLocale,
} from "../../../../../../utils/get-date-time-locale";

import React, { useMemo } from "react";
import {
  Action,
  ActionField,
  ActionsFields,
  Header,
  InitialAction,
  InitialRegisterTitle,
  ReviewsContainer,
} from "./styles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "1vh 1vw",
  },
  button: {
    ...theme.typography.subtitle1,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    minWidth: 180,
    minHeight: 50,
    borderRadius: 25,
    marginTop: "5vh",
  },
  spacer: {
    marginBottom: 20,
  },
  success: {
    backgroundColor: theme.palette.success.dark,
    borderRadius: 5,
    height: 50,
  },
  label: {
    ...theme.typography.subtitle1,
    color: theme.palette.primary.contrastText,
  },
  icon: {
    color: theme.palette.primary.contrastText,
    fontSize: 30,
    marginRight: 50,
  },
  titleModal: {
    color: "#031795",
    fontWeight: "bold",
    fontSize: "20px",
  },
}));

const ReviewsModal = ({ setModalStatus, t, actions }) => {
  const classes = useStyles();
  const { i18n } = useTranslation();
  const formattedActions = useMemo(() => {
    const saoPauloOffset = -3 * 60; // Sao Paulo is UTC-3

    return actions.map((action) => {
      let createdDateInBrazilianTimezone = undefined;

      if (action?.createDate) {
        const utcDate = new Date(action?.createDate);
        createdDateInBrazilianTimezone = new Date(
          utcDate.getTime() + saoPauloOffset * 60 * 1000
        );
      }

      if (action?.actionHistory?.length < 1) {
        return {
          initialValue: {
            createDate: createdDateInBrazilianTimezone,
            requester: action?.requester,
            anyoneCanRequest: action?.anyoneCanRequest,
            firstResponsible: action?.firstResponsible,
            secondResponsible: action?.secondResponsible,
            actionRequester: action?.actionRequester,
            action: action?.action,
            actionNumber: action?.actionNumber,
            deadline: action?.deadline,
          },
          actionHistory: [],
        };
      }

      const lastReviewItem = {
        createDate: createdDateInBrazilianTimezone,
        requester: action?.requester,
        firstResponsible: action?.firstResponsible,
        actionRequester: action?.actionRequester,
        secondResponsible: action?.secondResponsible,
        anyoneCanRequest: action?.anyoneCanRequest,
        action: action?.action,
        actionNumber: action?.actionNumber,
        deadline: action?.deadline,
        requesterReviewer: action?.requesterReviewer,
        reviewer: action?.reviewer,
      };

      const newHistory = action?.actionHistory?.filter(
        (item) =>
          item.id !== action?.actionHistory[action.actionHistory?.length - 1].id
      );

      newHistory.push(lastReviewItem);

      if (action?.actionHistory[action.actionHistory?.length - 1]?.createDate) {
        const utcDate = new Date(
          action?.actionHistory[action.actionHistory?.length - 1]?.createDate
        );
      }

      return {
        initialValue: {
          createDate:
            action?.actionHistory[action.actionHistory?.length - 1]?.createDate,
          requester:
            action?.actionHistory[action.actionHistory?.length - 1]?.requester,
          firstResponsible:
            action?.actionHistory[action.actionHistory?.length - 1]
              ?.firstResponsible,
          secondResponsible:
            action?.actionHistory[action.actionHistory?.length - 1]
              ?.secondResponsible,
          anyoneCanRequest:
            action?.actionHistory[action.actionHistory?.length - 1]
              ?.anyoneCanRequest,
          actionRequester:
            action?.actionHistory[action.actionHistory?.length - 1]
              ?.actionRequester,
          action:
            action?.actionHistory[action.actionHistory?.length - 1]?.action,
          actionNumber:
            action?.actionHistory[action.actionHistory?.length - 1]
              ?.actionNumber,
          deadline:
            action?.actionHistory[action.actionHistory?.length - 1]?.deadline,
        },
        actionHistory: newHistory,
      };
    });
  }, [actions, i18n.language]);

  return (
    <div>
      <Header>
        <span
          style={{ float: "right", cursor: "pointer" }}
          onClick={() => {
            setModalStatus(false);
          }}
        >
          [X] Fechar
        </span>
        <span className={classes.titleModal}>{t(`menu.minutes.reviews`)}</span>
      </Header>

      <ReviewsContainer>
        {formattedActions?.map((action) => (
          <Action>
            <h1>{` ${
              action?.actionHistory[action.actionHistory?.length - 1]?.action ||
              action?.initialValue?.action
            }`}</h1>

            <InitialAction>
              <InitialRegisterTitle>{`${t(
                "forms.minutes.actions.initialRegister"
              )}:`}</InitialRegisterTitle>

              <ActionsFields>
                <ActionField>
                  <span>{`${t("forms.minutes.actions.createdDate")}:`}</span>
                  <span>
                    {action?.initialValue?.createDate
                      ? format(
                          new Date(action?.initialValue?.createDate),
                          getDateFormats(i18n.language),
                          { locale: getDateTimeLocale(i18n.language) }
                        )
                      : ""}
                  </span>
                </ActionField>

                <ActionField>
                  <span>{`${t(
                    "forms.minutes.actions.actionRequester"
                  )}:`}</span>
                  <span>{action?.initialValue?.actionRequester || ""}</span>
                </ActionField>

                <ActionField>
                  <span>{`${t(
                    "forms.minutes.actions.responsibleName"
                  )}:`}</span>
                  <span>{action?.initialValue?.firstResponsible || ""}</span>
                </ActionField>

                <ActionField>
                  <span>{`${t(
                    "forms.minutes.actions.secoundResponsibleName"
                  )}:`}</span>
                  <span>{action?.initialValue?.secondResponsible || ""}</span>
                </ActionField>

                <ActionField>
                  <span>{`${t("description")}:`}</span>
                  <span>{action?.initialValue?.action || ""}</span>
                </ActionField>

                <ActionField>
                  <span>{`${t("forms.minutes.actions.actionNumber")}:`}</span>
                  <span>{action?.initialValue?.actionNumber || ""}</span>
                </ActionField>

                <ActionField>
                  <span>{`${t("anyoneCanRequest")}:`}</span>
                  <span>
                    {action?.initialValue?.anyoneCanRequest
                      ? t("forms.dialog.yes")
                      : t("forms.dialog.no")}
                  </span>
                </ActionField>

                <ActionField>
                  <span>{`${t("forms.minutes.actions.deadline")}:`}</span>
                  <span>
                    {action?.initialValue?.deadline
                      ? format(
                          new Date(action?.initialValue?.deadline),
                          getDateFormats(i18n.language),
                          { locale: getDateTimeLocale(i18n.language) }
                        )
                      : ""}
                  </span>
                </ActionField>
              </ActionsFields>
            </InitialAction>

            {action.actionHistory.map((review, index) => (
              <InitialAction>
                <InitialRegisterTitle>{`${t("review")} ${
                  index + 1
                }:`}</InitialRegisterTitle>

                <ActionsFields>
                  <ActionField>
                    <span>{`${t(
                      "forms.minutes.actions.reviewerRequester"
                    )}:`}</span>
                    <span>{review?.requesterReviewer || ""}</span>
                  </ActionField>

                  <ActionField>
                    <span>{`${t("forms.minutes.actions.reviewer")}:`}</span>
                    <span>{review?.reviewer || ""}</span>
                  </ActionField>
                </ActionsFields>

                <ActionsFields>
                  <ActionField>
                    <span>{`${t("forms.minutes.actions.createdDate")}:`}</span>
                    <span>
                      {review.createDate
                        ? format(
                            new Date(review.createDate),
                            getDateFormats(i18n.language),
                            { locale: getDateTimeLocale(i18n.language) }
                          )
                        : ""}
                    </span>
                  </ActionField>

                  <ActionField>
                    <span>{`${t(
                      "forms.minutes.actions.actionRequester"
                    )}:`}</span>
                    <span>{review?.actionRequester || ""}</span>
                  </ActionField>

                  <ActionField>
                    <span>{`${t(
                      "forms.minutes.actions.responsibleName"
                    )}:`}</span>
                    <span>{review?.firstResponsible || ""}</span>
                  </ActionField>

                  <ActionField>
                    <span>{`${t(
                      "forms.minutes.actions.secoundResponsibleName"
                    )}:`}</span>
                    <span>{review?.secondResponsible || ""}</span>
                  </ActionField>

                  <ActionField>
                    <span>{`${t("description")}:`}</span>
                    <span>{review?.action || ""}</span>
                  </ActionField>

                  <ActionField>
                    <span>{`${t("forms.minutes.actions.actionNumber")}:`}</span>
                    <span>{review?.actionNumber || ""}</span>
                  </ActionField>

                  <ActionField>
                    <span>{`${t("anyoneCanRequest")}:`}</span>
                    <span>
                      {review?.anyoneCanRequest
                        ? t("forms.dialog.yes")
                        : t("forms.dialog.no")}
                    </span>
                  </ActionField>

                  <ActionField>
                    <span>{`${t("forms.minutes.actions.deadline")}:`}</span>
                    <span>
                      {review.deadline
                        ? format(
                            new Date(review.deadline),
                            getDateFormats(i18n.language),
                            {
                              locale: getDateTimeLocale(i18n.language),
                            }
                          )
                        : ""}
                    </span>
                  </ActionField>
                </ActionsFields>
              </InitialAction>
            ))}
          </Action>
        ))}
      </ReviewsContainer>
    </div>
  );
};

export default ReviewsModal;
